import Vue from 'vue'

Vue.filter('undefined', (value) => {
  return value || '<span>&mdash;</span>'
})
